export const en = {
    'on-condition-mobile': 'for "Mobile devices" criteria',
    'on-condition-perfomance': 'for "Smart ads" criteria',
    'on-condition-video': 'for "Ads with video extensions" criteria'
};
